import React from "react";
import Modal from "react-bootstrap/Modal";

const ModalEnableWeeklyLimitConfirmation = ({ show, onConfirm, onClose, isEnabling }) => {
  return (
    <Modal show={show} size="lg" centered onHide={onClose}>
      <Modal.Body>
        <div className="modal__wrapper">
          <div className="inner__modal">
            <div className="replace__modal text-center">
              <div className="replace__icon mb-3">
                <img src="/img/modalwarn.svg" alt="modalwarn" />
              </div>
              {isEnabling ? (
                <p>
                  Enabling weekly limits will import all your existing members into this list and set a default limit of 2 orders per week.
                  This ensures that no member can place more than two orders in a week.
                  You can remove the limit for any member by enabling the <b>No Limit Applied</b> option.
                </p>
              ) : (
                <p>
                  By disabling the weekly limit, allows members to place unlimited orders each day and week.
                </p>
              )}

              <div className="replace__buttons mt-4 d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="close__replace"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="replace__confirm"
                  onClick={onConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalEnableWeeklyLimitConfirmation;
